import { gql } from '@apollo/client'

export default gql`
  query mortgageWidgetSubmission(
    $uuid: String
    $productTypes: [MortgageWidgetProductTypeEnum!]
    $lenderCentricProducts: Boolean
    $loanTypes: [WidgetLoanTypeEnum!]
    $sortingField: MortgagesMortgageSortingTypeEnum # required for lenderCentricProducts
    $bestProduct: Boolean # required for lenderCentricProducts
  ) {
    mortgageWidgetSubmission(
      uuid: $uuid
      lenderCentricProducts: $lenderCentricProducts
      sortingField: $sortingField
    ) {
      uuid
      ficoType
      vertical
      zipCode
      estimatedValue
      status
      downPayment
      homeValue
      loanAmount
      occupancyType
      propertyType
      cashOut
      products(productTypes: $productTypes, loanTypes: $loanTypes, bestProduct: $bestProduct) {
        closingCost
        discount
        uuid
        externalProductId
        lender {
          name
          nmls
          slug
          purchaseRating
        }
        monthlyPayment
        productType
        loanTerm
        loanType
        amortizationType
        rate
        apr
        fees
        bestProduct
      }
    }
  }
`
